import { useContext, useEffect, useState } from "react";
import { updateMany } from "../../../api/onboarding";
import { GeaoContext } from "../GeaoContextProvider";

export default function useInterviewUpdater(
    pageName,
    pageStatus,
    agentAnswers,
    agencyAnswers,
    activityRequest = null
) {
    const { agentInterview, setAgentInterview, agencyInterview, setAgencyInterview } = useContext(GeaoContext);

    const [updatingInterviews, setUpdatingInterviews] = useState(false);
    const [interviewsUpdated, setInterviewsUpdated] = useState(false);
    const [updateErrors, setUpdateErrors] = useState();

    useEffect(() => {
        setInterviewsUpdated(false);
        setUpdateErrors(null);

        const updateAgentInterviewRequest = {
            identityType: "Agent",
            interview: {
                ...agentInterview,
                questionAnswers: {
                    ...agentInterview?.questionAnswers,
                    ...agentAnswers
                },
                pageStatus: {
                    ...agentInterview?.pageStatus,
                    [pageName]: pageStatus
                }
            },
            activityRequest: activityRequest
        }

        const updateAgencyInterviewRequest = {
            identityType: "Agency",
            interview: {
                ...agencyInterview,
                questionAnswers: {
                    ...agencyInterview?.questionAnswers,
                    ...agencyAnswers
                },
                pageStatus: {
                    ...agencyInterview?.pageStatus,
                    [pageName]: pageStatus
                }
            }
        }

        if (agentAnswers || agencyAnswers) {
            setUpdatingInterviews(true);

            updateMany([
                updateAgentInterviewRequest,
                updateAgencyInterviewRequest
            ],
                updatedInterviews => {
                    // Success callback
                    setAgentInterview(updatedInterviews.find(i => i.interviewId === agentInterview.interviewId));
                    setAgencyInterview(updatedInterviews.find(i => i.interviewId === agencyInterview.interviewId));
                    setInterviewsUpdated(true);
                },
                () => {
                    // Finally callback
                    setUpdatingInterviews(false);
                },
                errors => {
                    // Error callback
                    setUpdateErrors(errors);
                });
        }
    }, [
        pageName,
        pageStatus,
        agentAnswers,
        agencyAnswers
    ]);

    return {
        updatingInterviews,
        interviewsUpdated,
        updateErrors
    };
}

// Re-export PageStatus for backward compatibility
export { PageStatus } from "../constants/PageStatus";